import "./InputDateSlider.scss";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import Icon from "core/icon/Icon";
import en from "date-fns/locale/en-CA";
import fr from "date-fns/locale/fr";
import { LANG } from "constants/constants";
import { useEffect } from "react";
import PropTypes from "prop-types";

const CustomDatePickerInput = ({ value, onClick }) => (
  <div className="custom-datepicker" onClick={onClick}>
    <Icon color="violet" icon="calendar" />
    <span>{value}</span>
  </div>
);

const InputDateSlider = ({ lang, selectedDate, setSelectedDate }) => {
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  useEffect(() => {
    const locale = lang === LANG.FR ? fr : en;
    registerLocale(lang, locale);
    setDefaultLocale(lang);
  }, [lang]);

  const handleMonthChange = (increment) => {
    const newDate = new Date(selectedDate);
    newDate.setMonth(newDate.getMonth() + increment);
    setSelectedDate(newDate);
  };

  return (
    <div className="column-date-content">
      <div onClick={() => handleMonthChange(-1)} className="element">{`<`}</div>
      <div className="element">
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="MMMM yyyy"
          showMonthYearPicker
          className="custom-datepicker"
          customInput={<CustomDatePickerInput />}
        />
      </div>
      <div onClick={() => handleMonthChange(+1)} className="element">{`>`}</div>
    </div>
  );
};

InputDateSlider.propTypes = {
  lang: PropTypes.string,
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  setSelectedDate: PropTypes.func.isRequired,
};

InputDateSlider.defaultProps = {
  lang: LANG.EN,
};

export default InputDateSlider;
